var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37165 6.05361C4.78049 4.11284 6.80904 2.71614 9.11889 2.09652C11.4287 1.47691 13.8802 1.67183 16.0643 2.64879C18.2484 3.62575 20.0331 5.32567 21.1205 7.46493C22.208 9.6042 22.5326 12.0535 22.0401 14.4041C21.5476 16.7548 20.2677 18.8646 18.4141 20.3818C16.5605 21.8989 14.2453 22.7315 11.8545 22.7408C9.46379 22.75 7.14219 21.9353 5.27704 20.4325C3.41188 18.9298 2.11596 16.8298 1.60547 14.483",
    stroke: "black",
    strokeWidth: 2.64283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32031 1.32129V7.68033H7.64912",
    stroke: "black",
    strokeWidth: 2.64283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08984 11.5244H15.7433",
    stroke: "black",
    strokeWidth: 2.64283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "static/media/return-icon.4351a5677ee1cafba7e1beab431c1b0f.svg";
export { ForwardRef as ReactComponent };